'use strict';

import React, {useState, useEffect, useRef, useMemo} from 'react';
import {Map as IMap} from 'immutable';
import * as d3 from 'd3';

import TS from '@zerolight/zlthunder-time-utils';

const MinSparks = 4;
const MaxSparks = 10;

function Sparks({series}) {
	const canvas = useRef(null);
	const [size, setSize] = useState(null);
	useEffect(() => {
		let c = canvas.current;
		if (!c) {
			return;
		}
		let {width, height} = c.getBoundingClientRect();
		if (width && height) {
			setSize(s => {
				if (s === null) {
					return new IMap({width, height})
				}
				return s.withMutations(s => {
					s.set('width', width);
					s.set('height', height);
				});
			});
		}
	}, [canvas.current]);

	const line = useMemo(() => {
		if (!size) {
			return null;
		}

		let {width, height} = size.toJS();
		let to = TS.hour(new Date()).valueOf();
		let from = TS.validate(to.valueOf() - (MinSparks * TS.HOUR)).valueOf();
		let minValue = 0;
		let maxValue = 0;

		for (let {ts, value} of series) {
			from = TS.min(from, ts).valueOf();
			maxValue = Math.max(maxValue, value);
		}

		if (maxValue === 0) {
			return null;
		}

		let values = [];
		for (let h = to; h >= from; h = h - TS.HOUR) {
			let point = series.find(({ts}) => ts.valueOf() === h);
			let value = point && Number(point.value);
			values.push({ts: TS.validate(h), value: !isNaN(value) ? value : 0});
		}

		const xScale = d3.scaleUtc()
			.domain([to, from])
			.range([0, width]).nice();

		const yScale = d3.scaleLinear()
			.domain([minValue, maxValue])
			.range([height, 0]).nice();

		const line = d3.line()
			.x(d => xScale(d.ts))
			.y(d => yScale(d.value));

		const area = d3.area()
			.x(d => xScale(d.ts))
			.y0(height + 2)
			.y1(d => yScale(d.value));

		return <>
			<path d={area(values)} className="area" />
			<path d={line(values)} className="line" />
		</>
	}, [size, series]);

	return <svg ref={canvas} xmlns="http://www.w3.org/2000/svg">{line}</svg>
}

export default Sparks;